module.exports = __webpack_public_path__ + "img/logo-germanavila.6795f47a.png";